import { render } from "./SbpUnPaidBills.vue?vue&type=template&id=6be4c5b6&scoped=true"
import script from "./SbpUnPaidBills.vue?vue&type=script&lang=js"
export * from "./SbpUnPaidBills.vue?vue&type=script&lang=js"

import "./SbpUnPaidBills.vue?vue&type=style&index=0&id=6be4c5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be4c5b6"]])

export default __exports__